<wbo-multi-select-control [valueField]="valueField"
                          [labelField]="labelField"
                          [summaryLabelField]="summaryLabelField"
                          [placeholder]="placeholder"
                          [attr.id]="elementId"
                          [(value)]="value"
                          [sourceSearchModel]="model"
                          [data]="data"
                          (onDataLoaded)="onDataLoaded($event)"
                          [multiObjectValueType]="multiObjectValueType"
                          [readonly]="isReadonly"
                          [pillRemovable]="pillRemovable"
                          [showSelections]="showSelections"
                          [formControlValidation]="formControl"
                          [labelSearchField]="labelSearchField"
                          [valueSearchField]="valueSearchField"
                          [label]="label"
                          (onSelect)="onSelect.emit($event)"
                          [overrideOpenView]="overrideOpenView"
                          (onOptionOpen)="onOptionOpen($event)"
                          (focussed)="onFocus($event)"
                          [showOptionOpenOption]="showOptionOpenOption"
                          [hideOptionOpenOption]="hideOptionOpenOption"
                          [extendedSearchComponent]="extendedSearchComponent"
                          [extendedSearchComponentParams]="extendedSearchComponentParams"
                          [extendedEditComponent]="extendedEditComponent"
                          [extendedEditComponentParams]="extendedEditComponentParams"
                          [viewFilter]="viewFilter">
</wbo-multi-select-control>
